import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { getEnumMap, isEmptyOrWhiteSpace } from "@/utils/Common";

import SectionPanel from "@/views/components/SectionPanel.vue";
import Ipc from "@/views/components/IpcTag.vue";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentInfo',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
},
  setup(__props) {

const props = __props;



const store = useStore();

const activeGroup = ref("info");
const expandInfoItems = ref(["num", "applicant", "ipc", "claim", "abst"]);
const expandTimeItems = ref(["expired"]);
const expandLawItems = ref(["status", "history"]);

const patentInfo = computed<any>(() => props.patent || {});
const patentText = computed<any>(() => patentInfo.value.patentText || {});

const ipcList = computed<string[]>(() =>
  (patentInfo.value.ipc || "")
    .split(/;\s*/)
    .map((item: string) => item.trim())
    .filter((item: string) => !isEmptyOrWhiteSpace(item))
);

// 著录项目信息下显示独立权利要求(indv_claim, 来自 WIPS reptClaim 全量, 可能多条);
// 老数据无 indv_claim 时回退取全部权利要求中的第一条近似展示
const claimsText = computed<string>(() => {
  const indvClaim: string = patentText.value.indvClaim || "";
  if (indvClaim.trim()) {
    return indvClaim;
  }
  const claims: string = patentText.value.claims || "";
  if (!claims.trim()) {
    return "";
  }
  const normalized = claims.replace(/\r?\n/g, "<br/>");
  const first = normalized
    .split(/(?:^|<br\s*\/?>)\s*(?=\d{1,3}[\.、，])/)
    .map((part: string) => part.replace(/^<br\s*\/?>/, "").trim())
    .filter((part: string) => !!part)[0];
  return first || claims;
});
const abstractText = computed<string>(() => patentText.value.abstractInfo || "");

const patentTypeLabel = computed<string>(() => {
  const map = getEnumMap(store.getters["enums/getEnumsByKey"]("PatentType"));
  return map.get(patentInfo.value.patentType) || "";
});

// 届满日: 发明20年 / 实用新型10年 / 外观设计15年, 自申请日起算
const expireDate = computed<string>(() => {
  const appDate: string = patentInfo.value.appDate || "";
  if (isEmptyOrWhiteSpace(appDate)) {
    return "";
  }
  const yearsMap: Record<string, number> = { FM: 20, SYXX: 10, WG: 15 };
  const years = yearsMap[patentInfo.value.patentType] ?? 20;
  const date = new Date(appDate.replace(/-/g, "/"));
  if (isNaN(date.getTime())) {
    return "";
  }
  date.setFullYear(date.getFullYear() + years);
  const pad = (n: number) => (n < 10 ? "0" + n : "" + n);
  return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
});

// 法律状态履历: 兼容 JSON [{AN,DT,LS,INFO}] 与 "事件名   事件日期" 文本两种格式
const legalRows = computed<Array<{ date: string; name: string; content: string }>>(() => {
  const note: string = (patentText.value.leagalNote || "").trim();
  if (isEmptyOrWhiteSpace(note)) {
    return [];
  }
  if (note.startsWith("[")) {
    try {
      return (JSON.parse(note) || []).map((item: any) => ({
        date: item.DT || item.occurDate || "",
        name: item.LS || item.lastStatus || "",
        content: item.INFO || item.info || "",
      }));
    } catch {
      // 非法 JSON 时按文本解析
    }
  }
  return note
    .split(/\r?\n/)
    .filter((line: string) => !!line.trim())
    .map((line: string) => {
      const parts = line.trim().split(/\s{2,}/);
      if (parts.length >= 2) {
        return { date: parts[1], name: parts[0], content: parts[2] || "" };
      }
      return { date: "", name: line.trim(), content: "" };
    });
});

const setActiveGroup = (key: string) => {
  activeGroup.value = key;
};

return { __sfc: true,props, store, activeGroup, expandInfoItems, expandTimeItems, expandLawItems, patentInfo, patentText, ipcList, claimsText, abstractText, patentTypeLabel, expireDate, legalRows, setActiveGroup, isEmptyOrWhiteSpace, SectionPanel, Ipc }
}

})